export const routes = {
    recorder: {
      name: 'recorder',
      path: '/voice-recorder',
    },
    list: {
      name: 'list',
      path: '/voice-list',
    },
  }
  